const localization = {
  removeLabel: 'Remove',
}

export default localization
